import { connect } from 'react-redux';
import view from './view';
import { hiddenPopup, loadContent, loadContentByUrlAsync } from './action'
import { EventModel } from './model'

const stateToProps = (state) => state.popup;
const actionToProps = new EventModel({ hiddenPopup, loadContent, loadContentByUrlAsync });

export default connect(stateToProps, actionToProps)(view);